import Banner from "../components/banner";
import Careers from "../components/careers";
import Program from "../components/program";
import Testimonials from "../components/testimonials";
import useAnalytics from "../hooks/useAnalytics";
import CTA from "../components/CTA";
import useSlickAccessibility from "../hooks/useSlickAccessibility";
import { Helmet } from "react-helmet";
import { useState } from "react";
import AnimationContainer from "../components/animationContainer";

function Programs() {
  useAnalytics("Our Programs - North American Institute of Swiss Watchmaking");
  useSlickAccessibility();

  const [program, setProgram] = useState(1);

  return (
    <>
      <Helmet>
        <title>
          Our Programs - North American Institute of Swiss Watchmaking
        </title>
        <meta
          name="description"
          content="Programs at the North American School of Swiss Watchmaking, including encasing technicians, customer service repairs, and internships"
        />
        <meta
          name="keywords"
          content="encasing, technician, watchmaker, skills, repairs, internship, WOSTEP, school, watchmaking, swiss, apply, craftsmanship, learn, horology"
        />
      </Helmet>
      <div>
        <Banner
          title="Our Programs"
          subtitle="NAIOSW offers three different WOSTEP-certified programs designed to educate and inspire students with a curiosity and passion for horology, equipping them with the skills and knowledge necessary for a successful and rewarding career in the watchmaking industry."
        />
        <div className="layout bg-white py-24 p-10 md:p-20 flex flex-col items-start">
          <button
            onClick={() => (program !== 1 ? setProgram(1) : setProgram(0))}
            className="flex gap-5 items-center mb-8 md:w-max w-full justify-between"
          >
            <h2
              className={`transition-all text-3xl md:text-4xl text-left duration-700 ${
                program === 1
                  ? "border-l-[3px] border-black pl-8 font-medium"
                  : ""
              }`}
            >
              Customer Service Watchmaker
            </h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`size-6 transtion-all duration-500 !shrink-0 ${
                program === 1 ? "rotate-90" : ""
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
          {program === 1 && (
            <AnimationContainer animation="fade-in" classes="w-full">
              <Program
                id="1"
                length="1 YEAR PROGRAM"
                description="The Customer Service Watchmaker Program teaches students the necessary skills in watchmaking service operations, through both practical and theoretical training."
                focus={{
                  description: "This program focuses on: ",
                  bullets: [
                    "Fundamentals of Micromechanics",
                    "Watch Encasing",
                    {
                      "Watch Servicing": [
                        "Quartz, Mechanical, Chronograph and Automatic Calibers",
                      ],
                    },
                    "Repair and Adjustment Procedure",
                  ],
                }}
                requirements={[
                  "Authorized to work in the United States",
                  "High School Degree or GED",
                  "No watchmaking experience requirement",
                ]}
                link="/apply"
              />
            </AnimationContainer>
          )}

          <button
            onClick={() => (program !== 2 ? setProgram(2) : setProgram(0))}
            className="flex gap-5 items-center mb-8 md:w-max w-full justify-between"
          >
            <h2
              className={`transition-all text-3xl md:text-4xl text-left duration-700 ${
                program === 2
                  ? "border-l-[3px] border-black pl-8 font-medium"
                  : ""
              }`}
            >
              Encasing Technician
            </h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`size-6 transtion-all duration-500 !shrink-0 ${
                program === 2 ? "rotate-90" : ""
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
          {program === 2 && (
            <AnimationContainer animation="fade-in" triggerOnce={false}>
              <Program
                id="2"
                length="4 MONTH PROGRAM"
                description="The Encasing Technician Course teaches students the necessary skills in micromechanics and basic watch encasing service operations, through both practical and theoretical training, to prepare them for a successful career."
                focus={{
                  description: "This course focuses on:",
                  bullets: [
                    "Fundamentals of Micromechanics",
                    "Watch Encasing",
                    "Repair and Adjustment Procedures",
                    "Movement Exchange",
                  ],
                }}
                requirements={[
                  "Authorized to work in the United States",
                  "High School Degree or GED",
                  "No watchmaking experience requirement",
                ]}
                link="/apply"
              />
            </AnimationContainer>
          )}

          <button
            className="flex gap-5 items-center mb-8 md:w-max w-full justify-between"
            onClick={() => (program !== 3 ? setProgram(3) : setProgram(0))}
          >
            <h2
              className={`transition-all text-3xl md:text-4xl text-left duration-700 ${
                program === 3
                  ? "border-l-[3px] border-black pl-8 font-medium"
                  : ""
              }`}
            >
              High School Summer Internship
            </h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`size-6 transtion-all duration-500 !shrink-0 ${
                program === 3 ? "rotate-90" : ""
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
          {program === 3 && (
            <AnimationContainer animation="fade-in">
              <Program
                id="3"
                length="SIX WEEK PROGRAM"
                description="With our internship, students have an opportunity to work in the Technical Workshop at Richemont for a period of six weeks, supporting different functions of the Repair Operation."
                subdescription="A one-week training will take place regarding Micro-Mechanics and how tools and products are handled.  This will be to prepare the individual for what they will be participating in the remaining 5 weeks!"
                link="/apply"
              />
            </AnimationContainer>
          )}
        </div>

        <Testimonials />
        <Careers />
      </div>
    </>
  );
}

export default Programs;
